<template>
  <div>
    <h3 class="mb-3">
      Serviços
    </h3>

    <v-row>
      <v-col>
        <v-autocomplete
          :no-data-text="$t('table.noResults')"
          :value="value"
          :items="serviceTypes"
          item-text="name"
          item-value="value"
          multiple
          clearable
          :rules="rules"
          @change="handleSelect"
          outlined
          dense
        >
          <template v-slot:selection="data">
            <v-chip class="my-2">
              <v-avatar left>
                <v-img
                  width="24"
                  height="24"
                  v-html="getIcon(data.item.value)"
                />
              </v-avatar>

              {{ $t(`type.${data.item.value}`) }}
            </v-chip>
          </template>
          <template slot="item" slot-scope="data">
            <div class="d-flex">
              {{ data.value }}
              <v-img
                class="mr-4"
                width="24"
                height="24"
                v-html="getIcon(data.item.value)"
              />
              {{ $t(`type.${data.item.value}`) }}
            </div>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          @click="onUpdate"
          :loading="loading"
          :disabled="serviceButtonRules"
          color="primary"
        >
          Atualizar Serviços
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { icons } from '@/util/iconsSVG'

export default {
  name: 'CityServices',
  props: {
    rules: {
      required: false,
    },
    onUpdate: {
      type: Function,
      required: true,
    },
    serviceButtonRules: {
      type: Boolean,
      required: true,
    },
    loading: Boolean,
    value: Array,
  },
  data() {
    return {
      selectedServiceTypes: [],
    }
  },
  async mounted() {
    await this.fetchServiceTypes()
  },
  computed: {
    ...mapGetters(['serviceTypes', 'isLoading']),
  },
  methods: {
    ...mapActions(['fetchServiceTypes']),

    handleSelect(value) {
      this.$emit('input', value)
    },
    getIcon(type) {
      return icons[type]
    },
  },
}
</script>

<style></style>
